import { useLocation } from '@reach/router';

export const useSearchParams = () => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);

  return urlSearchParams;
};
